'use strict'

import {bootstrap} from '../bootstrap/bootstrap'

export function trackEvent(category, action, label = '', value = '') {
  if (typeof ga === 'function') { // eslint-disable-line no-undef
    ga('send', 'event', category, action, label, value) // eslint-disable-line no-undef
  }
}

const anchorEvents = Array.from(document.querySelectorAll('[data-ga-event="true"]'))

bootstrap(anchorEvents, anchorTest => {
  const category = anchorTest.getAttribute('data-ga-category')
  const action = anchorTest.getAttribute('data-ga-action')
  const label = anchorTest.getAttribute('data-ga-label') === null ? '' : anchorTest.getAttribute('data-ga-label')
  const value = anchorTest.getAttribute('data-ga-value') === null ? '' : anchorTest.getAttribute('data-ga-value')

  if (category && action) {
    anchorTest.addEventListener('click', () => {
      trackEvent(category, action, label, value)
    })
  }
})
